<template>
  <section id="delivery-fields">
    <div class="row">
      <template v-for="(field, fieldName) in deliveryFields">
        <Textarea
          v-if="field.type === 'textarea'"
          :placeholder="$t(field.placeholder_key)"
          :name="fieldName"
          :value="cartData.customer[fieldName]"
          @updated-value="updatedField"
        />
        <Input
          v-else
          :classes="field.classes"
          :placeholder="$t(field.placeholder_key)"
          :type="field.type"
          :maxlength="field.maxlength"
          :name="fieldName"
          :rules="field.rules"
          :value="cartData.customer[fieldName] || field.defaultValue"
          @updated-value="updatedField"
        />
      </template>
    </div>
  </section>
</template>
<script>
import { deliveryFields } from "../../../../form";
import { mapGetters } from "vuex";
import Input from "../../partials/input/Input";
import Textarea from "../../partials/input/Textarea";
import useCart from "../useCart";

export default {
  components: {
    Input,
    Textarea,
  },
  computed: {
    ...mapGetters({
      cartData: "cart/getCartData",
    }),
  },
  methods: {
    updatedField(event) {
      this.cartData.customer[event.name] = event.value;
    },
  },
  setup(props) {
    const { setCartLocalStorage } = useCart();

    return {
      deliveryFields,
      setCartLocalStorage,
    };
  },
};
</script>
